// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { ErrorResponse } from '../models';
import { ResourceCategory } from '../models';
import { UsersList } from '../models';
import { ValidationErrorResponse } from '../models';
import { Webinar } from '../models';
import { WebinarEdit } from '../models';
import { WebinarList } from '../models';
/**
 * WebinarApi - axios parameter creator
 * @export
 */
export const WebinarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * **Security:** `root` or (`company.enabled` and (`webinar.owner` or `webinar.company.owner`))
         * @summary Add viewers to webinar.
         * @param {string} id 
         * @param {Array<string>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addViewers(id: string, body?: Array<string>, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling addViewers.');
            }
            const localVarPath = `/v1/webinar/{id}/viewers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or (`filter.company` and (`company.owner` or `company.employee`)) or (`filter.viewer` and `webinar.viewer`)  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">viewer</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get categories.
         * @param {string} [viewerId] 
         * @param {string} [companyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categories(viewerId?: string, companyId?: string, options: any = {}): RequestArgs {
            const localVarPath = `/v1/webinar/categories`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (viewerId !== undefined) {
                localVarQueryParameter['viewerId'] = viewerId;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or (`company.enabled` and (`webinar.owner` or `webinar.company.owner`))
         * @summary Edit webinar.
         * @param {string} id 
         * @param {WebinarEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: WebinarEdit, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling edit.');
            }
            const localVarPath = `/v1/webinar/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or `webinar.owner` or `webinar.company.owner` or (`webinar.viewer` and `webinar.enabled`)
         * @summary Get single webinar.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling get.');
            }
            const localVarPath = `/v1/webinar/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">and</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"webinar.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"webinar.company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.document_manager\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get webinar viewers.
         * @param {string} id 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewers(id: string, offset?: number, limit?: number, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getViewers.');
            }
            const localVarPath = `/v1/webinar/{id}/viewers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">viewer</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get webinars list by criteria.
         * @param {Array<string>} [ids] 
         * @param {string} [title] 
         * @param {string} [companyId] 
         * @param {string} [ownerId] 
         * @param {string} [categoryId] 
         * @param {string} [viewerId] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {boolean} [enabled] 
         * @param {string} [locale] 
         * @param {Date} [startedAtMin] 
         * @param {Date} [startedAtMax] 
         * @param {Date} [finishedAtMin] 
         * @param {Date} [finishedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {'coming' | 'running' | 'finished'} [status] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'title' | 'startedAt' | 'finishedAt' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(ids?: Array<string>, title?: string, companyId?: string, ownerId?: string, categoryId?: string, viewerId?: string, priceMin?: number, priceMax?: number, enabled?: boolean, locale?: string, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, status?: 'coming' | 'running' | 'finished', offset?: number, limit?: number, sort?: 'title' | 'startedAt' | 'finishedAt' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options: any = {}): RequestArgs {
            const localVarPath = `/v1/webinars`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (ownerId !== undefined) {
                localVarQueryParameter['ownerId'] = ownerId;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (viewerId !== undefined) {
                localVarQueryParameter['viewerId'] = viewerId;
            }

            if (priceMin !== undefined) {
                localVarQueryParameter['priceMin'] = priceMin;
            }

            if (priceMax !== undefined) {
                localVarQueryParameter['priceMax'] = priceMax;
            }

            if (enabled !== undefined) {
                localVarQueryParameter['enabled'] = enabled;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (startedAtMin !== undefined) {
                localVarQueryParameter['startedAtMin'] = (startedAtMin as any).toISOString();
            }

            if (startedAtMax !== undefined) {
                localVarQueryParameter['startedAtMax'] = (startedAtMax as any).toISOString();
            }

            if (finishedAtMin !== undefined) {
                localVarQueryParameter['finishedAtMin'] = (finishedAtMin as any).toISOString();
            }

            if (finishedAtMax !== undefined) {
                localVarQueryParameter['finishedAtMax'] = (finishedAtMax as any).toISOString();
            }

            if (createdAtMin !== undefined) {
                localVarQueryParameter['createdAtMin'] = (createdAtMin as any).toISOString();
            }

            if (createdAtMax !== undefined) {
                localVarQueryParameter['createdAtMax'] = (createdAtMax as any).toISOString();
            }

            if (updatedAtMin !== undefined) {
                localVarQueryParameter['updatedAtMin'] = (updatedAtMin as any).toISOString();
            }

            if (updatedAtMax !== undefined) {
                localVarQueryParameter['updatedAtMax'] = (updatedAtMax as any).toISOString();
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get webinars list of current user.
         * @param {string} [title] 
         * @param {string} [companyId] 
         * @param {string} [categoryId] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {Date} [startedAtMin] 
         * @param {Date} [startedAtMax] 
         * @param {Date} [finishedAtMin] 
         * @param {Date} [finishedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {'coming' | 'running' | 'finished'} [status] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        my(title?: string, companyId?: string, categoryId?: string, priceMin?: number, priceMax?: number, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, status?: 'coming' | 'running' | 'finished', offset?: number, limit?: number, options: any = {}): RequestArgs {
            const localVarPath = `/v1/webinars/my`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            if (title !== undefined) {
                localVarQueryParameter['title'] = title;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['companyId'] = companyId;
            }

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (priceMin !== undefined) {
                localVarQueryParameter['priceMin'] = priceMin;
            }

            if (priceMax !== undefined) {
                localVarQueryParameter['priceMax'] = priceMax;
            }

            if (startedAtMin !== undefined) {
                localVarQueryParameter['startedAtMin'] = (startedAtMin as any).toISOString();
            }

            if (startedAtMax !== undefined) {
                localVarQueryParameter['startedAtMax'] = (startedAtMax as any).toISOString();
            }

            if (finishedAtMin !== undefined) {
                localVarQueryParameter['finishedAtMin'] = (finishedAtMin as any).toISOString();
            }

            if (finishedAtMax !== undefined) {
                localVarQueryParameter['finishedAtMax'] = (finishedAtMax as any).toISOString();
            }

            if (createdAtMin !== undefined) {
                localVarQueryParameter['createdAtMin'] = (createdAtMin as any).toISOString();
            }

            if (createdAtMax !== undefined) {
                localVarQueryParameter['createdAtMax'] = (createdAtMax as any).toISOString();
            }

            if (updatedAtMin !== undefined) {
                localVarQueryParameter['updatedAtMin'] = (updatedAtMin as any).toISOString();
            }

            if (updatedAtMax !== undefined) {
                localVarQueryParameter['updatedAtMax'] = (updatedAtMax as any).toISOString();
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or (`company.enabled` and (`webinar.owner` or `webinar.company.owner`))
         * @summary Remove viewers from webinar.
         * @param {string} id 
         * @param {Array<string>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeViewers(id: string, body?: Array<string>, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling removeViewers.');
            }
            const localVarPath = `/v1/webinar/{id}/viewers`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * **Security:** `root` or (`company.enabled` and (`webinar.owner` or `webinar.company.owner`))
         * @summary Delete webinar.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WebinarIdDelete(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling v1WebinarIdDelete.');
            }
            const localVarPath = `/v1/webinar/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("X-API-TOKEN")
                    : configuration.apiKey;
                localVarHeaderParameter["X-API-TOKEN"] = localVarApiKeyValue;
            }

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }


    
            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WebinarApi - functional programming interface
 * @export
 */
export const WebinarApiFp = function(configuration?: Configuration) {
    return {
        /**
         * **Security:** `root` or (`company.enabled` and (`webinar.owner` or `webinar.company.owner`))
         * @summary Add viewers to webinar.
         * @param {string} id 
         * @param {Array<string>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addViewers(id: string, body?: Array<string>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = WebinarApiAxiosParamCreator(configuration).addViewers(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or (`filter.company` and (`company.owner` or `company.employee`)) or (`filter.viewer` and `webinar.viewer`)  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">viewer</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get categories.
         * @param {string} [viewerId] 
         * @param {string} [companyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categories(viewerId?: string, companyId?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResourceCategory> {
            const localVarAxiosArgs = WebinarApiAxiosParamCreator(configuration).categories(viewerId, companyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or (`company.enabled` and (`webinar.owner` or `webinar.company.owner`))
         * @summary Edit webinar.
         * @param {string} id 
         * @param {WebinarEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: WebinarEdit, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Webinar> {
            const localVarAxiosArgs = WebinarApiAxiosParamCreator(configuration).edit(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or `webinar.owner` or `webinar.company.owner` or (`webinar.viewer` and `webinar.enabled`)
         * @summary Get single webinar.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Webinar> {
            const localVarAxiosArgs = WebinarApiAxiosParamCreator(configuration).get(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">and</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"webinar.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"webinar.company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.document_manager\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get webinar viewers.
         * @param {string} id 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewers(id: string, offset?: number, limit?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersList> {
            const localVarAxiosArgs = WebinarApiAxiosParamCreator(configuration).getViewers(id, offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">viewer</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get webinars list by criteria.
         * @param {Array<string>} [ids] 
         * @param {string} [title] 
         * @param {string} [companyId] 
         * @param {string} [ownerId] 
         * @param {string} [categoryId] 
         * @param {string} [viewerId] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {boolean} [enabled] 
         * @param {string} [locale] 
         * @param {Date} [startedAtMin] 
         * @param {Date} [startedAtMax] 
         * @param {Date} [finishedAtMin] 
         * @param {Date} [finishedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {'coming' | 'running' | 'finished'} [status] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'title' | 'startedAt' | 'finishedAt' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(ids?: Array<string>, title?: string, companyId?: string, ownerId?: string, categoryId?: string, viewerId?: string, priceMin?: number, priceMax?: number, enabled?: boolean, locale?: string, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, status?: 'coming' | 'running' | 'finished', offset?: number, limit?: number, sort?: 'title' | 'startedAt' | 'finishedAt' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarList> {
            const localVarAxiosArgs = WebinarApiAxiosParamCreator(configuration).list(ids, title, companyId, ownerId, categoryId, viewerId, priceMin, priceMax, enabled, locale, startedAtMin, startedAtMax, finishedAtMin, finishedAtMax, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, status, offset, limit, sort, order, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Get webinars list of current user.
         * @param {string} [title] 
         * @param {string} [companyId] 
         * @param {string} [categoryId] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {Date} [startedAtMin] 
         * @param {Date} [startedAtMax] 
         * @param {Date} [finishedAtMin] 
         * @param {Date} [finishedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {'coming' | 'running' | 'finished'} [status] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        my(title?: string, companyId?: string, categoryId?: string, priceMin?: number, priceMax?: number, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, status?: 'coming' | 'running' | 'finished', offset?: number, limit?: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<WebinarList> {
            const localVarAxiosArgs = WebinarApiAxiosParamCreator(configuration).my(title, companyId, categoryId, priceMin, priceMax, startedAtMin, startedAtMax, finishedAtMin, finishedAtMax, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, status, offset, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or (`company.enabled` and (`webinar.owner` or `webinar.company.owner`))
         * @summary Remove viewers from webinar.
         * @param {string} id 
         * @param {Array<string>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeViewers(id: string, body?: Array<string>, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = WebinarApiAxiosParamCreator(configuration).removeViewers(id, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * **Security:** `root` or (`company.enabled` and (`webinar.owner` or `webinar.company.owner`))
         * @summary Delete webinar.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WebinarIdDelete(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void> {
            const localVarAxiosArgs = WebinarApiAxiosParamCreator(configuration).v1WebinarIdDelete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * WebinarApi - factory interface
 * @export
 */
export const WebinarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * **Security:** `root` or (`company.enabled` and (`webinar.owner` or `webinar.company.owner`))
         * @summary Add viewers to webinar.
         * @param {string} id 
         * @param {Array<string>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addViewers(id: string, body?: Array<string>, options?: any) {
            return WebinarApiFp(configuration).addViewers(id, body, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or (`filter.company` and (`company.owner` or `company.employee`)) or (`filter.viewer` and `webinar.viewer`)  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">viewer</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get categories.
         * @param {string} [viewerId] 
         * @param {string} [companyId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categories(viewerId?: string, companyId?: string, options?: any) {
            return WebinarApiFp(configuration).categories(viewerId, companyId, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or (`company.enabled` and (`webinar.owner` or `webinar.company.owner`))
         * @summary Edit webinar.
         * @param {string} id 
         * @param {WebinarEdit} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(id: string, body?: WebinarEdit, options?: any) {
            return WebinarApiFp(configuration).edit(id, body, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or `webinar.owner` or `webinar.company.owner` or (`webinar.viewer` and `webinar.enabled`)
         * @summary Get single webinar.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(id: string, options?: any) {
            return WebinarApiFp(configuration).get(id, options)(axios, basePath);
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">and</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"webinar.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"webinar.company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.document_manager\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get webinar viewers.
         * @param {string} id 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewers(id: string, offset?: number, limit?: number, options?: any) {
            return WebinarApiFp(configuration).getViewers(id, offset, limit, options)(axios, basePath);
        },
        /**
         *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">viewer</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
         * @summary Get webinars list by criteria.
         * @param {Array<string>} [ids] 
         * @param {string} [title] 
         * @param {string} [companyId] 
         * @param {string} [ownerId] 
         * @param {string} [categoryId] 
         * @param {string} [viewerId] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {boolean} [enabled] 
         * @param {string} [locale] 
         * @param {Date} [startedAtMin] 
         * @param {Date} [startedAtMax] 
         * @param {Date} [finishedAtMin] 
         * @param {Date} [finishedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {'coming' | 'running' | 'finished'} [status] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {'title' | 'startedAt' | 'finishedAt' | 'createdAt' | 'updatedAt'} [sort] 
         * @param {'ASC' | 'DESC'} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(ids?: Array<string>, title?: string, companyId?: string, ownerId?: string, categoryId?: string, viewerId?: string, priceMin?: number, priceMax?: number, enabled?: boolean, locale?: string, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, status?: 'coming' | 'running' | 'finished', offset?: number, limit?: number, sort?: 'title' | 'startedAt' | 'finishedAt' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any) {
            return WebinarApiFp(configuration).list(ids, title, companyId, ownerId, categoryId, viewerId, priceMin, priceMax, enabled, locale, startedAtMin, startedAtMax, finishedAtMin, finishedAtMax, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, status, offset, limit, sort, order, options)(axios, basePath);
        },
        /**
         * 
         * @summary Get webinars list of current user.
         * @param {string} [title] 
         * @param {string} [companyId] 
         * @param {string} [categoryId] 
         * @param {number} [priceMin] 
         * @param {number} [priceMax] 
         * @param {Date} [startedAtMin] 
         * @param {Date} [startedAtMax] 
         * @param {Date} [finishedAtMin] 
         * @param {Date} [finishedAtMax] 
         * @param {Date} [createdAtMin] 
         * @param {Date} [createdAtMax] 
         * @param {Date} [updatedAtMin] 
         * @param {Date} [updatedAtMax] 
         * @param {'coming' | 'running' | 'finished'} [status] 
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        my(title?: string, companyId?: string, categoryId?: string, priceMin?: number, priceMax?: number, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, status?: 'coming' | 'running' | 'finished', offset?: number, limit?: number, options?: any) {
            return WebinarApiFp(configuration).my(title, companyId, categoryId, priceMin, priceMax, startedAtMin, startedAtMax, finishedAtMin, finishedAtMax, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, status, offset, limit, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or (`company.enabled` and (`webinar.owner` or `webinar.company.owner`))
         * @summary Remove viewers from webinar.
         * @param {string} id 
         * @param {Array<string>} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeViewers(id: string, body?: Array<string>, options?: any) {
            return WebinarApiFp(configuration).removeViewers(id, body, options)(axios, basePath);
        },
        /**
         * **Security:** `root` or (`company.enabled` and (`webinar.owner` or `webinar.company.owner`))
         * @summary Delete webinar.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WebinarIdDelete(id: string, options?: any) {
            return WebinarApiFp(configuration).v1WebinarIdDelete(id, options)(axios, basePath);
        },
    };
};

/**
 * WebinarApi - object-oriented interface
 * @export
 * @class WebinarApi
 * @extends {BaseAPI}
 */
export class WebinarApi extends BaseAPI {
    /**
     * **Security:** `root` or (`company.enabled` and (`webinar.owner` or `webinar.company.owner`))
     * @summary Add viewers to webinar.
     * @param {string} id 
     * @param {Array<string>} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarApi
     */
    public addViewers(id: string, body?: Array<string>, options?: any) {
        return WebinarApiFp(this.configuration).addViewers(id, body, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or (`filter.company` and (`company.owner` or `company.employee`)) or (`filter.viewer` and `webinar.viewer`)  **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">viewer</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Get categories.
     * @param {string} [viewerId] 
     * @param {string} [companyId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarApi
     */
    public categories(viewerId?: string, companyId?: string, options?: any) {
        return WebinarApiFp(this.configuration).categories(viewerId, companyId, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or (`company.enabled` and (`webinar.owner` or `webinar.company.owner`))
     * @summary Edit webinar.
     * @param {string} id 
     * @param {WebinarEdit} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarApi
     */
    public edit(id: string, body?: WebinarEdit, options?: any) {
        return WebinarApiFp(this.configuration).edit(id, body, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or `webinar.owner` or `webinar.company.owner` or (`webinar.viewer` and `webinar.enabled`)
     * @summary Get single webinar.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarApi
     */
    public get(id: string, options?: any) {
        return WebinarApiFp(this.configuration).get(id, options)(this.axios, this.basePath);
    }

    /**
     *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.enabled\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">and</span> <span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"webinar.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"webinar.company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.document_manager\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">webinar</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">getCompany</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #008a19; font-weight: bold;\">)</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Get webinar viewers.
     * @param {string} id 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarApi
     */
    public getViewers(id: string, offset?: number, limit?: number, options?: any) {
        return WebinarApiFp(this.configuration).getViewers(id, offset, limit, options)(this.axios, this.basePath);
    }

    /**
     *   **Security:** <pre style=\"display: block; background: rgba(0,0,0,.05); padding: 0.5em; line-height: 1.5em;\"><span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"root\"</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.owner\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"company.employee\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">company</span><span style=\"color: #008a19; font-weight: bold;\">)</span> <span style=\"color: #008a19; font-weight: bold;\">or</span> <span style=\"color: #001d8a; font-weight: bold;\">is_granted</span><span style=\"color: #008a19; font-weight: bold;\">(</span><span style=\"color: #da031f; font-weight: bold;\">\"user.current\"</span><span style=\"color: #008a19; font-weight: bold;\">,</span> <span style=\"color: #001d8a; font-weight: bold;\">filter</span><span style=\"color: #008a19; font-weight: bold;\">.</span><span style=\"color: #001d8a; font-weight: bold;\">viewer</span><span style=\"color: #008a19; font-weight: bold;\">)</span></pre> 
     * @summary Get webinars list by criteria.
     * @param {Array<string>} [ids] 
     * @param {string} [title] 
     * @param {string} [companyId] 
     * @param {string} [ownerId] 
     * @param {string} [categoryId] 
     * @param {string} [viewerId] 
     * @param {number} [priceMin] 
     * @param {number} [priceMax] 
     * @param {boolean} [enabled] 
     * @param {string} [locale] 
     * @param {Date} [startedAtMin] 
     * @param {Date} [startedAtMax] 
     * @param {Date} [finishedAtMin] 
     * @param {Date} [finishedAtMax] 
     * @param {Date} [createdAtMin] 
     * @param {Date} [createdAtMax] 
     * @param {Date} [updatedAtMin] 
     * @param {Date} [updatedAtMax] 
     * @param {'coming' | 'running' | 'finished'} [status] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {'title' | 'startedAt' | 'finishedAt' | 'createdAt' | 'updatedAt'} [sort] 
     * @param {'ASC' | 'DESC'} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarApi
     */
    public list(ids?: Array<string>, title?: string, companyId?: string, ownerId?: string, categoryId?: string, viewerId?: string, priceMin?: number, priceMax?: number, enabled?: boolean, locale?: string, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, status?: 'coming' | 'running' | 'finished', offset?: number, limit?: number, sort?: 'title' | 'startedAt' | 'finishedAt' | 'createdAt' | 'updatedAt', order?: 'ASC' | 'DESC', options?: any) {
        return WebinarApiFp(this.configuration).list(ids, title, companyId, ownerId, categoryId, viewerId, priceMin, priceMax, enabled, locale, startedAtMin, startedAtMax, finishedAtMin, finishedAtMax, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, status, offset, limit, sort, order, options)(this.axios, this.basePath);
    }

    /**
     * 
     * @summary Get webinars list of current user.
     * @param {string} [title] 
     * @param {string} [companyId] 
     * @param {string} [categoryId] 
     * @param {number} [priceMin] 
     * @param {number} [priceMax] 
     * @param {Date} [startedAtMin] 
     * @param {Date} [startedAtMax] 
     * @param {Date} [finishedAtMin] 
     * @param {Date} [finishedAtMax] 
     * @param {Date} [createdAtMin] 
     * @param {Date} [createdAtMax] 
     * @param {Date} [updatedAtMin] 
     * @param {Date} [updatedAtMax] 
     * @param {'coming' | 'running' | 'finished'} [status] 
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarApi
     */
    public my(title?: string, companyId?: string, categoryId?: string, priceMin?: number, priceMax?: number, startedAtMin?: Date, startedAtMax?: Date, finishedAtMin?: Date, finishedAtMax?: Date, createdAtMin?: Date, createdAtMax?: Date, updatedAtMin?: Date, updatedAtMax?: Date, status?: 'coming' | 'running' | 'finished', offset?: number, limit?: number, options?: any) {
        return WebinarApiFp(this.configuration).my(title, companyId, categoryId, priceMin, priceMax, startedAtMin, startedAtMax, finishedAtMin, finishedAtMax, createdAtMin, createdAtMax, updatedAtMin, updatedAtMax, status, offset, limit, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or (`company.enabled` and (`webinar.owner` or `webinar.company.owner`))
     * @summary Remove viewers from webinar.
     * @param {string} id 
     * @param {Array<string>} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarApi
     */
    public removeViewers(id: string, body?: Array<string>, options?: any) {
        return WebinarApiFp(this.configuration).removeViewers(id, body, options)(this.axios, this.basePath);
    }

    /**
     * **Security:** `root` or (`company.enabled` and (`webinar.owner` or `webinar.company.owner`))
     * @summary Delete webinar.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WebinarApi
     */
    public v1WebinarIdDelete(id: string, options?: any) {
        return WebinarApiFp(this.configuration).v1WebinarIdDelete(id, options)(this.axios, this.basePath);
    }

}
